import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../env/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  code_do: number = JSON.parse(sessionStorage.getItem('selectedDo') || '{}').code_interne;
  host_Contact = `${environment.API_URI}/api/contact/${this.code_do}`;

  constructor(private http: HttpClient) { }

    private getAuthHeaders(): HttpHeaders {
    const purecloud_auth_data = localStorage.getItem('purecloud_auth_data');
    const token = purecloud_auth_data ? JSON.parse(purecloud_auth_data).accessToken : null;

    if (!token) throw new Error("Missing access token");

    return new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
  }

  // Récupérer la liste des contacts
  getAllContactsByCodeDo(code_do: number) {
    const url = `${environment.API_URI}/api/contact/${code_do}/select/all`;
    return this.http.get(url, { headers: this.getAuthHeaders() });
  }

  // Ajouter un nouveau contact
  addContact(contact: any) {
    const url = `${this.host_Contact}/add`;
    return this.http.post(url, contact, { headers: this.getAuthHeaders() });
  }
  disableOneOrManyContacts(code_Internes: number[]) {
    const url = `${this.host_Contact}/disable`;
    const body = { code_interne: code_Internes };
    return this.http.post(url, body, { headers: this.getAuthHeaders() });
  }
  enableOneOrManyContacts(code_Internes: number[]) {
    const url = `${this.host_Contact}/enable`;
    const body = { code_interne: code_Internes };
    return this.http.post(url, body, { headers: this.getAuthHeaders() });
  }
  updateContact(code_interne: number, Contact: any) {
    const url = `${this.host_Contact}/update/${code_interne}`;
    return this.http.put(url, Contact, { headers: this.getAuthHeaders() });
  }
}
